import {Component} from 'panel';

import timing from '../../stylesheets/mixins/timing.json';
import {registerMPElement} from '../../util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

export enum ToastType {
  INFO = `info`,
  ERROR = `error`,
  SUCCESS = `success`,
}

export default registerMPElement(
  `mp-toast`,
  class extends Component<{}> {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        cta: `string`,
        hide: `boolean`,
        'is-error': {type: `boolean`, deprecatedMsg: `use attr "type" instead`},
        type: {
          type: `string`,
          enum: Object.values(ToastType),
          description: `The type of toast message which primarily determines the color`,
        },
        undoable: {type: `boolean`, description: `whether undo btn should be displayed`},
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
        defaultState: {
          delayRemove: timing[`$mp-fast`],
        },
        helpers: {
          ctaClick: () => this._triggerAction(),
          closeClick: () => this._triggerClose(),
          undoClick: () => this._triggerUndo(),
          getWidgetClass: () => {
            return {
              'mp-toast-is-error': this.attr(`is-error`) || this.attr(`type`) === ToastType.ERROR,
              'mp-toast-is-success': this.attr(`type`) === ToastType.SUCCESS,
            };
          },
        },
      };
    }

    public connectedCallback() {
      super.connectedCallback();
      [`action`, `undo`].forEach((eventName) => {
        this.addEventListener(
          eventName,
          (ev) => {
            if (!ev.defaultPrevented) {
              this._triggerClose();
            }
          },
          true,
        );
      });
    }

    private _triggerAction() {
      this.dispatchEvent(new CustomEvent(`action`));
    }

    private _triggerClose() {
      this.dispatchEvent(new CustomEvent(`close`));
    }

    private _triggerUndo() {
      this.dispatchEvent(new CustomEvent(`undo`));
    }
  },
);
